// GA4 광고 태그 인터페이스
const ga4TagInterface = (item_name, item_id, promotion_id, promotion_name, creative_name, location_id) => {
    const obj = {
        item_name: item_name,
        item_id: item_id,
        promotion_id: promotion_id,
        promotion_name: promotion_name,
        creative_name: creative_name,
        location_id: location_id
    }
    return obj
}

// UA 광고 태그 인터페이스
// const uaTagInterface = (id, name, creative, position) => {
//     const obj = {
//         id: id,
//         name: name,
//         creative: creative,
//         position: position
//     }
//     return obj
// }

// GA4 태그 Push
const ga4Push = (eventName, itemData) => {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: eventName,
        ecommerce: {
            items: itemData
        }
    });
    // console.log(window.dataLayer)
}

// UA 태그 Push
// const uaPush = (obj, type) => {
//
//     // console.log(type);
//
//     /*
//     / description: 노출/클릭 분기처리
//     / type: string (view, click)
//     / 필요 시 case 추가
//     */
//     switch (type) {
//         case 'view':
//             window.dataLayer.push({ ecommerce: null });
//             window.dataLayer.push({
//                 'event': 'promotionImpression',
//                 'ecommerce': {
//                     'promoView': {
//                         'promotions': obj
//                     }
//                 }
//             });
//             break;
//         case "click":
//             window.dataLayer.push({
//                 'event': 'promotionClick',
//                 'ecommerce': {
//                     'promoClick': {
//                         'promotions': obj
//                     }
//                 },
//                 'eventCallback': function () {
//                 }
//             });
//             break;
//         default:
//             console.error("태그 설정 오류")
//             break;
//     }
//     // console.log(window.dataLayer);
// }

// 2021-12-23 SYC : GA4 검색광고 노출 태그 추가
export const ga4_AdView = (adKeyword) => {

    const ga4_ViewItem = [
        ga4TagInterface(
            null,
            null,
            adKeyword.mall_name + '_' + adKeyword.idx_b_manager,
            adKeyword.nm_ad,
            adKeyword.ad_id,
            'null_null'
        ),
    ]
    ga4Push("view_promotion", ga4_ViewItem)
}

// 2021-12-23 SYC : GA4 검색광고 클릭 태그 추가
export const ga4_AdClick = (adKeyword) => {

    const ga4_Clickitem = [
        ga4TagInterface(
            null,
            null,
            adKeyword.mall_name + '_' + adKeyword.idx_b_manager,
            adKeyword.nm_ad,
            adKeyword.ad_id,
            'null_null'
        ),
    ]
    ga4Push("select_promotion", ga4_Clickitem)
}

// 검색광고 노출 태그
// export const ua_AdView = (adKeyword) => {
//
//     window.dataLayer.push({ ecommerce: null });
//     window.dataLayer.push({
//         'event': 'promotionImpression',
//         'ecommerce': {
//             'promoView': {
//                 'promotions': [
//                     {
//                         'id': id,
//                         'name': name,
//                         'creative': creative,
//                         'position': position
//                     }
//                 ]
//             }
//         }
//     });
//
//     const ua_ViewItem = [
//         uaTagInterface(
//             adKeyword.mall_name + '_' + adKeyword.idx_b_manager,
//             adKeyword.nm_ad,
//             adKeyword.ad_id,
//             'null_null'
//         ),
//     ]
//     uaPush(ua_ViewItem, "view");
// }

// 검색광고 클릭 태그
// export const ua_AdClick = (adKeyword) => {
//
//     window.dataLayer.push({
//         'event': 'promotionClick',
//         'ecommerce': {
//             'promoClick': {
//                 'promotions': [
//                     {
//                         'id': id,
//                         'name': name,
//                         'creative': creative,
//                         'position': position
//                     }
//                 ]
//             }
//         },
//         'eventCallback': function () {
//         }
//     });
//
//     const ua_ClickItem = [
//         uaTagInterface(
//             adKeyword.mall_name + '_' + adKeyword.idx_b_manager,
//             adKeyword.nm_ad,
//             adKeyword.ad_id,
//             'null_null'
//         ),
//     ]
//
//     uaPush(ua_ClickItem, "click");
// }



// WEBPACK FOOTER //
// ./src/common/libs/googleTagManager.js